import { render, staticRenderFns } from "./SignOff.vue?vue&type=template&id=31091b9c&"
import script from "./SignOff.vue?vue&type=script&lang=js&"
export * from "./SignOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports